import { useMemo } from 'react';
import { animationSettings } from '../constants/components/scenes/elf/animations';
import { upperFirstLetter } from '../utils/helpers/helpers';

export const useElfStateControls = (wrapper) => {
  return useMemo(() => {
    if (!wrapper) return;

    return Object.keys(animationSettings.states).reduce(
      (acc, state) => {
        const key = `set${upperFirstLetter(state)}`;
        return { ...acc, [key]: () => wrapper?.setElfState(state) };
      },
      {
        setState(state) {
          if (animationSettings.states.hasOwnProperty(state)) wrapper?.setElfState(state);
        },
      },
    );
  }, [wrapper]);
};
